import { ITheme, IStyle, mergeStyleSets, MessageBarType } from "@fluentui/react";
import { DoorRecommendation } from "../../../entities-generated/common/door-recommendation";
import { IShowAnnouncementBannerArgs } from "../../../framework/components/bwj-announcement/props";

export const getStyles = (theme: ITheme) => {
  const recommendedSection: IStyle = {
    padding: 0,
    paddingBottom: '3rem',
    borderBottom: `1px solid ${theme.palette.neutralTertiary}`,
    margin: 0,
  };

  const heading: IStyle = {
    fontSize: theme.fonts.xLarge.fontSize,
    fontWeight: 700,
    lineHeight: theme.fonts.xLarge.lineHeight,
    margin: 0,
    padding: 0,
  };

  const recommendedHeading: IStyle = {
    ...heading,
    marginBottom: '1.5em',

    '& > span.subtext': {
      display: 'block',
      fontSize: theme.fonts.smallPlus.fontSize,
      lineHeight: theme.fonts.smallPlus.lineHeight,
      fontWeight: 500,
    }
  };

  const generalHeading: IStyle = {
    ...heading,
    margin: '1.5em 0',
  };

  return mergeStyleSets({
    recommendedSection,
    recommendedHeading,
    generalHeading,
  });
}

export const saveErrorArgs: IShowAnnouncementBannerArgs = {
  messageType: MessageBarType.error,
  message: '<strong>Our bad</strong> &ndash; an error occurred.  Please try making your selection again',
  dismissable: true,
  renderAsHtml: true,
};

export const recommendedSectionRecommendation = (recommendation: DoorRecommendation) => {
  if(recommendation === DoorRecommendation.DistantRelative) { return DoorRecommendation.Standard; }
  return recommendation;
}